import { TrendingDown, TrendingUp } from "lucide-react";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import type { HealthMoverRow, TrendDirection } from "@busright/data-contract";

import { shortId } from "@/lib/format";

// =================================================================================================
// FhMoversList — MoM score movers, each row drillable to the Districts worklist.
//
// Each mover is a district (districtId) — there's no per-district route, but the Districts surface
// is the at-risk worklist for exactly these districts, so a mover row navigates there. Rows are real
// keyboard controls (Enter/Space activate, visible focus ring) rather than plain <div>s.
// =================================================================================================

const MOVER_CLASS: Record<TrendDirection, string> = { UP: "up", DOWN: "down", FLAT: "flat" };

export interface FhMoversListProps {
  readonly movers: readonly HealthMoverRow[];
  readonly max: number;
}

export const FhMoversList = ({ movers, max }: FhMoversListProps): ReactNode => {
  const navigate = useNavigate();
  return (
    <div>
      {movers.slice(0, max).map((m) => (
        <button
          key={m.districtId}
          type="button"
          className="mover-row mover-row-drill"
          aria-label={`Open Districts — at-risk worklist for district ${shortId(m.districtId)}`}
          onClick={() => {
            void navigate("/districts");
          }}
        >
          <span className="mover-id">{shortId(m.districtId)}</span>
          <span className={`mover-change ${MOVER_CLASS[m.direction]}`}>
            {m.direction === "DOWN" ? <TrendingDown size={13} /> : <TrendingUp size={13} />}
            {m.scoreChange.toFixed(1)}
          </span>
        </button>
      ))}
    </div>
  );
};
